module.exports = __webpack_public_path__ + "static/img/business83.472ff0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business83.png
// module id = sRNZ
// module chunks = 9